<template>
    <div>
        <h3>{{ service.group }} Configuration</h3>
        <div class="row">
            <div class="col-12">
                <div class="sau-bx bx-pad">
                    <div class="row">
                        <div class="col-lg-12" v-if="!gotData">
                           <div class="row">
                                <!-- Fetching Data -->
                                <div class="col">
                                    <div class="text-center">
                                        <img src="/img/spinner.gif" />
                                        <h6 class="sau-pm-reset">
                                            Fetching Configuration
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="col-sm-12 col-md-6" v-if="gotData">
                            <ul class="sau-list-display">
                                <li>
                                    <h5>CPU</h5>
                                    <p>{{ service.custom["CPU"] }}</p>
                                </li>
                                <li>
                                    <h5>Disk Space</h5>
                                    <p>{{ service.custom["Disk Space"] }}</p>
                                </li>
                                 <li v-for="(val, key) in this.col1" :key="key">
                                    <h5>{{ val[0] }}</h5>
                                    <p>{{ val[1] }}</p>
                                </li>
                            </ul>
                        </div>

                        <div class="col-sm-12 col-md-6" v-if="gotData">
                            <ul class="sau-list-display">
                                <li>
                                    <h5>Memory</h5>
                                    <p>{{ service.custom["Memory"] }}</p>
                                </li>
                                <li>
                                    <h5>IP Address</h5>
                                    <p>{{ service.ipaddress }}</p>
                                </li>
                                <li v-for="(val, key) in this.col2" :key="key">
                                    <h5>{{ val[0] }}</h5>
                                    <p>{{ val[1] }}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <licensing></licensing>
                <div class="container" v-if="pendingApply">
                    <div class="row mt-10">
                        <div class="col text-center">
                            <p class="mb-2"><i class="fas fa-arrow-circle-down success text-4xl"></i></p>
                            <h5>Compute Update Pending</h5>
                            <p>This update requires a reboot to take effect and will take occur on the scheduled date below</p>
                        </div>
                    </div>
                    <div class="row border-2 border-grey-200 bg-grey-100 py-5">
                        <div class="col-12 col-md-6">
                            <div class="flex flex-col md:flex-row flex-wrap text-center md:text-left">
                                <div class="w-100 md:w-1/2" v-for="(resource, key) in newResources" :key="`newResource-${key}`">
                                    <label class="font-bold">{{ key }}</label>
                                    <p>{{ resource }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="d-flex flex-col md:flex-row md:items-end md:justify-end items-center flex-wrap">
                                <div class="mb-3 md:mb-0">
                                    <label for="inputDate" class="d-block font-bold">Scheduled Date</label>
                                    <datetime
                                        v-model="rebootTime"
                                        id="inputDate"
                                        type="datetime"
                                        class="mr-1 d-inline-block bg-white py-2"
                                        :min-datetime="minDateTime"
                                        :max-datetime="maxDateTime"
                                        :minute-step="15"
                                        value-zone="Australia/Sydney"
                                        zone="Australia/Sydney"
                                        placeholder="Select Date and Time"
                                    ></datetime>
                                </div>
                                <div>
                                    <button @click="scheduleRebootTime" class="btn btn-primary mr-1 font-bold btn-sm text-uppercase" :disabled="! rebootTime || schedulingReboot">Save</button>
                                    <button @click="rebootNow" class="btn btn-success font-bold btn-sm text-uppercase" :disabled="rebooting">Apply Now</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container" v-if="pendingDiskUpgrade">
                    <div class="row mt-10">
                        <div class="col text-center mb-0">
                            <p class="mb-2"><i class="fas fa-arrow-circle-down success text-4xl"></i></p>
                            <h5>Storage Update Pending</h5>
                            <p class="mb-0">This update requires a reboot to take effect</p>
                            <p>IMPORTANT: You can not downgrade your disk size after upgrading.</p>
                        </div>
                    </div>
                    <div class="row border-2 border-grey-200 bg-grey-100 py-5">
                        <div class="col-md-6">
                            <div class="flex flex-col flex-wrap">
                                <label class="font-bold">New Disk Space</label>
                                <p class="mb-0">{{ this.customDisk['New Disk Space'] }}</p>
                            </div>
                        </div>
                        <div class="col-md-6 text-right">
                            <button @click="startDiskUpgrade" class="btn btn-success font-bold btn-sm text-uppercase" :disabled="rebooting">Apply Now</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css'
import Licensing from '../Licensing';

export default {
    props: ['service'],
    components: {
        datetime: Datetime,
        'licensing': Licensing,
    },
    data() {
        return {
            filtered: [],
            formatted: [],
            col1: [],
            col2: [],
            pendingApply: 0,
            pendingDiskUpgrade: 0,
            pendingApplyCol1: [],
            pendingApplyCol2: [],
            pendingDiskUpgradeCol1: [],
            pendingDiskUpgradeCol2: [],
            customApply: [],
            customDisk: [],
            pendingDisk: [],
            upgrading: false,
            rebootTime: null,
            minDateTime: null,
            maxDateTime: null,
            schedulingReboot: false,
            rebooting: false,
            newResources: {},
        }
    },
    created() {
        this.startApp();
    },
    methods: {
        startApp() {
            this.vuexLoading().then(response => {
                this.getDeviceStatus().then(response => {
                    if(response.data) {
                        this.service.custom = [];
                        this.customDisk = [];
                        this.customApply = [];
                        this.pendingDiskUpgrade = this.pendingApply = 0;
                        /** Add to this.service.custom */
                        this.service.custom["CPU"] = response.data.data.cpuCount + ' Cores';
                        this.service.custom['Disk Space'] = this.formatBytes(response.data.data.diskSpace / 1024);
                        this.service.custom['Memory'] = this.formatBytes(response.data.data.ramCount * 1024);
                        // this.service.custom['Operating System'] = response.data.data.osName;

                        // Pending application?
                        if (response.data.data.pendingApply>0 && response.data.data.pendingApplyResources) {
                            this.pendingApply = 1;
                            this.customApply['Current CPU'] = response.data.data.cpuCount + ' Cores';
                            this.customApply['New CPU'] = response.data.data.pendingApplyResources.cpuCount + ' Cores';
                            this.customApply['Current Memory'] = this.formatBytes(response.data.data.ramCount * 1024);
                            this.customApply['New Memory'] = this.formatBytes(response.data.data.pendingApplyResources.ramCount);
                            this.customApply['Maximum Pending Date/Time'] = response.data.data.applyMaximumDatetime;
                            this.customApply['Scheduled Date/Time'] = response.data.data.applyScheduledDatetime;

                            this.newResources['New CPU'] = this.customApply['New CPU'];
                            this.newResources['New RAM'] = this.customApply['New Memory'];

                            this.maxDateTime = new Date(this.customApply['Maximum Pending Date/Time']).toISOString();
                            this.minDateTime = new Date().toISOString();
                            this.rebootTime = this.maxDateTime;

                            if(this.customApply['Scheduled Date/Time']) {
                                this.rebootTime = new Date(this.customApply['Scheduled Date/Time']).toISOString();
                            }
                        }

                        if (response.data.data.pendingDiskupgrade>0 && response.data.data.pendingDiskupgradeResources) {
                            this.pendingDiskUpgrade = 1;
                            this.customDisk['Current Disk Space'] = this.formatBytes(response.data.data.diskSpace / 1024);
                            this.customDisk['New Disk Space'] = this.formatBytes(response.data.data.pendingDiskupgradeResources.diskSpace / 1024);
                        }
                        this.formatDetails();
                    }
                }).catch(error => {})
            });
        },
        formatDetails() {
            this.pendingDiskUpgradeCol1 = [];
            this.pendingDiskUpgradeCol2 = [];
            this.pendingApplyCol1 = [];
            this.pendingApplyCol2 = [];
            this.formatted = [];
            let x = 1;
            let filtered = ['CPU', 'Disk Space', 'Memory', 'Operating System'];
            _.forIn(this.service.custom, function(val, key) {
                if(filtered.includes(key)) return;
                if(x % 2) {
                    this.col1.push([key, val]);
                } else {
                    this.col2.push([key, val]);
                }
                x++;
            }.bind(this));
            x = 1;
            _.forIn(this.customApply, function(val, key) {
                if(x % 2) {
                    this.pendingApplyCol1.push([key, val]);
                } else {
                    this.pendingApplyCol2.push([key, val]);
                }
                x++;
            }.bind(this));

            x = 1;
            _.forIn(this.customDisk, function(val, key) {
                if(x % 2) {
                    this.pendingDiskUpgradeCol1.push([key, val]);
                } else {
                    this.pendingDiskUpgradeCol2.push([key, val]);
                }
                x++;
            }.bind(this));

            this.formatted = _.chunk(this.filtered, Math.ceil(this.filtered.length / 2));
        },
        formatBytes(amount) {

            if(amount / 1073741824 > 1) {
                return Math.round(amount / 1073741824) + ' TiB';
            }
            if(amount / 1048576 > 1) {
                return Math.round(amount / 1048576) + ' GiB';
            }
            if(amount / 1024 > 1) {
                return Math.round(amount / 1024) + ' MiB';
            }
            return amount + ' B';
        },

        startDiskUpgrade() {
            this.upgrading = true;

            this.postRequest(`/api/services/vds/${this.service.id}/start-disk-upgrade`)
                .then((response) => {
                    if(response.data.result == 'success') {
                        this.$swal({
                            toast: true,
                            type:'success',
                            title: 'Disk upgrade has been queued and will be completed shortly',
                            showConfirmButton: false,
                            timer: 3000
                        });
                        // reload the server status after 10 seconds
                        setTimeout(() => {
                            this.startApp();
                            this.upgrading = false;
                        }, 10000);

                    } else {
                        this.$swal({
                            type: 'error',
                            title: 'There was an error starting the disk upgrade process. Please contact support to resolve this issue.',
                            showConfirmButton: true,
                            customContainerClass: 'default-style-swal',
                        });
                        this.upgrading = false;
                    }
                })
        },

        scheduleRebootTime() {
            this.schedulingReboot = true;

            const rebootTime = moment(this.rebootTime).format('YYYY-MM-DD HH:mm:ss');

            this.postRequest(`/api/services/vds/${this.service.id}/schedule-maintenance-reboot`, { rebootTime: rebootTime })
                .then((response) => {
                    if(response.data.result == 'success') {
                        this.$swal({
                            toast: true,
                            type:'success',
                            title: 'The reboot has been scheduled and will be completed at the requested time',
                            showConfirmButton: false,
                            timer: 3000
                        });
                        this.startApp();
                    } else {
                        this.$swal({
                            type: 'error',
                            title: `There was an error scheduling the reboot.`,
                            text: response.data.message,
                            showConfirmButton: true,
                            customContainerClass: 'default-style-swal',
                        });
                        this.upgrading = false;
                    }
                }).finally(() => {
                    this.schedulingReboot = false;
                })
        },

        rebootNow() {
            this.rebooting = true;

            this.$swal({
                title: 'Reboot Now?',
                text: 'Are you sure you wish to apply resources now? This will take your server offline for 1-2 minutes while your upgrade/downgrade is processed.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, reboot it!',
                customContainerClass: 'default-style-swal',
            }).then((result) => {
                if (result.value) {
                    this.postRequest(`/api/services/vds/${this.service.id}/start-maintenance-reboot`)
                        .then((response) => {
                            if(response.data.result == 'success') {
                                this.$swal(
                                    'Confirmed!',
                                    'Your server is being rebooted. This process usually takes 1-2 minutes to complete.',
                                    'success'
                                )
                            } else {
                                this.$swal({
                                    type: 'error',
                                    title: `There was an error rebooting the server.`,
                                    text: response.data.message,
                                    showConfirmButton: true,
                                    customContainerClass: 'default-style-swal',
                                });
                            }
                        })
                }
            }).finally(() => {
                this.rebooting = false;
            })
        }
    },
}
</script>
<style scoped>
.vdatetime {
    padding: 8px 10px;
    font-size: 16px;
    border: solid 1px #ddd;
    color: #444;
}
</style>
